var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataSharingLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 74,
    cy: 74,
    r: 74
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "134.5%",
    height: "135.1%",
    x: "-17.2%",
    y: "-15.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 1.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 0.5,
    result: "shadowSpreadOuter3"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    in: "shadowSpreadOuter3",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter3",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74,
    r: 70,
    fill: "#9DD9E3",
    stroke: "#FFF",
    strokeLinejoin: "square",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.784 20.598)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#00234A",
    strokeLinecap: "square",
    strokeWidth: 7,
    d: "M72.267 26.411L26.991 53.112"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00234A",
    strokeWidth: 7,
    d: "M30.526 56.304l41.741 24.873"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.204,
    cy: 23.654,
    r: 13.06,
    fill: "#00234A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.96,
    cy: 53.112,
    r: 13.06,
    fill: "#00234A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.204,
    cy: 83.15,
    r: 13.06,
    fill: "#00234A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSharingLogo);
export default __webpack_public_path__ + "static/media/data-sharing-logo.c5a48558.svg";
export { ForwardRef as ReactComponent };